/* sucrase/dist/esm/transformers/NumericSeparatorTransformer.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    const tslib_1 = require("tslib");
    const types_1 = require("f0c35cbd76") /* ../parser/tokenizer/types */;
    const Transformer_1 = tslib_1.__importDefault(require("a46f119f74") /* ./Transformer */);
    class NumericSeparatorTransformer extends Transformer_1.default {
        constructor(tokens) {
            super();
            this.tokens = tokens;
            ;
        }
        process() {
            if (this.tokens.matches1(types_1.TokenType.num)) {
                const code = this.tokens.currentTokenCode();
                if (code.includes("_")) {
                    this.tokens.replaceToken(code.replace(/_/g, ""));
                    return true;
                }
            }
            return false;
        }
    }
    exports.default = NumericSeparatorTransformer;
}
